import React from 'react';
import './styles.scss';
import { FaWhatsapp } from 'react-icons/fa';

export default function MGMButton({ message }) {
	return (
		<button className='mgm-btn'>
			<a href={message} target='blank' rel='noopener'>
				<FaWhatsapp size={18} color={'#fff'} />
				Indicar a yalo
			</a>
		</button>
	);
}
